import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { breakpoints, palette } from 'main/ui'

export const avatarSizeDesktop = 88
export const avatarSizeMobile = 66

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const AvatarContainer = styled.div`
  background-color: ${palette.whiteDove};
  border-color: ${palette.whiteDove};
  border-radius: 50%;
  border-style: solid;
  border-width: 4px;
  height: ${avatarSizeMobile}px;
  width: ${avatarSizeMobile}px;

  @media (min-width: ${breakpoints.lg}px) {
    border-width: 6px;
    height: ${avatarSizeDesktop}px;
    width: ${avatarSizeDesktop}px;
  }
`

export const avatarImageStyles = css`
  border-radius: 50%;
`
